import React from "react";
import styled from "styled-components";
import CountryPhoneInput from "./CountryPhoneInput";
import { portalColors } from "./BusinessPortalComponents";
import { StandardModalText } from "./StandardModal";

export const ModalCountryPhoneInput = styled(CountryPhoneInput)`
    width: 100%;
    margin: 5px 0;

    .flag-dropdown,
    input.form-control {
        height: 42px !important;
        border-radius: var(--calendar-radius-input, 8px) !important;
    }

    input.form-control {
        width: calc(100% - 50px) !important;
        margin-left: 50px !important;
        padding: 0 12px !important;
        text-align: left;
        font-size: 0.875rem;
    }

    .form-control::placeholder {
        text-align: left;
    }
`;

const PhoneFieldShell = styled.div`
    position: relative;
    width: 100%;

    ${ModalCountryPhoneInput} {
        input.form-control {
            padding-left: 3.6rem !important;
        }
    }
`;

const DialCodeContainer = styled.div`
    position: absolute;
    height: 42px;
    top: 5px;
    left: 50px;
    display: flex;
    pointer-events: none;
`;

export function ModalPhoneInputWithDialCode({
    countryCode,
    dialCode,
    value,
    onChange,
    onMount,
    placeholder = "Mobile",
    ...props
}) {
    return (
        <PhoneFieldShell>
            <ModalCountryPhoneInput
                autoFormat={false}
                country={countryCode.toLowerCase()}
                disableCountryGuess={true}
                disableCountryCode={true}
                value={value}
                onMount={onMount}
                onChange={onChange}
                placeholder={placeholder}
                errors={[]}
                {...props}
            />
            <DialCodeContainer>
                <StandardModalText color={portalColors.textSoft} width="auto" margin="auto 0 auto 0.75rem">
                    +{dialCode}
                </StandardModalText>
            </DialCodeContainer>
        </PhoneFieldShell>
    );
}
